var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-card full-width q-px-sm q-py-md" },
    [
      _c(
        "q-list",
        { attrs: { separator: "" } },
        [
          _c(
            "q-collapsible",
            {
              attrs: {
                group: "costs",
                icon: "fas fa-money-bill-wave",
                label: _vm.$t("totals"),
                opened: ""
              }
            },
            [
              _c("q-table", {
                staticClass: "q-my-md",
                attrs: {
                  data: _vm.total_costs,
                  columns: _vm.columns_total_costs,
                  "row-key": "name",
                  pagination: _vm.server_pagination,
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [0],
                  "binary-state-sort": "",
                  "hide-bottom": ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.server_pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        {},
                        [
                          _c("q-td", { key: "name", attrs: { props: props } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t(props.row.name)) +
                                "\n                    "
                            )
                          ]),
                          props.row.name === "participants"
                            ? _c(
                                "q-td",
                                {
                                  key: "expected_total",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(props.row.expected_total) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _c(
                                "q-td",
                                {
                                  key: "expected_total",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                        $ " +
                                      _vm._s(props.row.expected_total) +
                                      "\n                    "
                                  )
                                ]
                              ),
                          props.row.editable
                            ? _c(
                                "q-td",
                                {
                                  key: "actual_total",
                                  attrs: { props: props }
                                },
                                [
                                  _c("q-input", {
                                    attrs: { type: "number", prefix: "$" },
                                    on: { input: _vm.calculateCosts },
                                    model: {
                                      value: props.row.actual_total,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "actual_total", $$v)
                                      },
                                      expression: "props.row.actual_total"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "q-td",
                                {
                                  key: "actual_total",
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        props.row.name === "participants"
                                          ? props.row.actual_total
                                          : "$" + props.row.actual_total
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "q-collapsible",
            {
              attrs: {
                group: "costs",
                icon: "fas fa-money-bill",
                label: _vm.$t("materials")
              }
            },
            [
              _c("q-table", {
                staticClass: "q-my-md",
                attrs: {
                  data: _vm.materials,
                  columns: _vm.columns_materials,
                  pagination: _vm.server_pagination,
                  "row-key": "material_id",
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [0],
                  "binary-state-sort": ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.server_pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        {},
                        [
                          _c(
                            "q-td",
                            { key: "material", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.row.material) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "qty_material", attrs: { props: props } },
                            [
                              _c("q-input", {
                                attrs: { type: "number", readonly: "" },
                                model: {
                                  value: props.row.qty_material,
                                  callback: function($$v) {
                                    _vm.$set(props.row, "qty_material", $$v)
                                  },
                                  expression: "props.row.qty_material"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            {
                              key: "unit_material_cost",
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n                        $ " +
                                  _vm._s(props.row.unit_material_cost) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "total_material_cost",
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n                        $ " +
                                  _vm._s(
                                    props.row.total_material_cost.toFixed(2)
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "q-collapsible",
            {
              attrs: {
                group: "costs",
                icon: "fas fa-money-check-alt",
                label: _vm.$t("additional_costs")
              }
            },
            [
              _c("q-table", {
                staticClass: "q-my-md",
                attrs: {
                  data: _vm.additional_costs,
                  columns: _vm.columns_additional_costs,
                  pagination: _vm.server_pagination,
                  "row-key": "cost_id",
                  "no-data-label": _vm.$t("no_data_avaliable"),
                  "no-results-label": _vm.$t("no_results_found"),
                  "loading-label": _vm.$t("loading_data"),
                  "rows-per-page-label": _vm.$t("items_per_page"),
                  "rows-per-page-options": [0],
                  "binary-state-sort": ""
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.server_pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "top",
                    fn: function(props) {
                      return [
                        _c("div", { staticClass: "col" }),
                        _c("q-btn", {
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-plus",
                            label: _vm.$t("add"),
                            disable: _vm.disableAddCosts
                          },
                          on: {
                            click: function($event) {
                              _vm.show_add_costs = true
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        {},
                        [
                          _c(
                            "q-td",
                            { key: "description", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(props.row.description) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "qty_additional_cost",
                              attrs: { props: props }
                            },
                            [
                              _c("q-input", {
                                attrs: { type: "number", readonly: "" },
                                model: {
                                  value: props.row.qty_additional_cost,
                                  callback: function($$v) {
                                    _vm.$set(
                                      props.row,
                                      "qty_additional_cost",
                                      $$v
                                    )
                                  },
                                  expression: "props.row.qty_additional_cost"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            {
                              key: "unit_additional_cost",
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n                        $ " +
                                  _vm._s(
                                    props.row.unit_additional_cost.toFixed(2)
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "total_additional_cost",
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n                        $ " +
                                  _vm._s(
                                    props.row.total_additional_cost.toFixed(2)
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "actions",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c("q-btn", {
                                attrs: {
                                  round: "",
                                  flat: "",
                                  icon: "fas fa-pen",
                                  color: "info"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editAdditionalCost(props.row)
                                  }
                                }
                              }),
                              _c("q-btn", {
                                attrs: {
                                  round: "",
                                  flat: "",
                                  icon: "fas fa-trash",
                                  color: "negative"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeAdditionalCost(
                                      props.row.id
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save_costs"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveTotalCosts()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearNewCost()
            },
            "escape-key": function($event) {
              return _vm.clearNewCost()
            }
          },
          model: {
            value: _vm.show_add_costs,
            callback: function($$v) {
              _vm.show_add_costs = $$v
            },
            expression: "show_add_costs"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_add_costs = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("include_additional_cost")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-field",
                      { attrs: { count: 256 } },
                      [
                        _c("q-input", {
                          attrs: {
                            type: "text",
                            "float-label": _vm.$t("description")
                          },
                          model: {
                            value: _vm.new_cost_description,
                            callback: function($$v) {
                              _vm.new_cost_description = $$v
                            },
                            expression: "new_cost_description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("quantity")
                      },
                      on: { input: _vm.calcNewCostTotal },
                      model: {
                        value: _vm.new_cost_qty,
                        callback: function($$v) {
                          _vm.new_cost_qty = $$v
                        },
                        expression: "new_cost_qty"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("unitary_value"),
                        prefix: "$"
                      },
                      on: { input: _vm.calcNewCostTotal },
                      model: {
                        value: _vm.new_cost_unit_cost,
                        callback: function($$v) {
                          _vm.new_cost_unit_cost = $$v
                        },
                        expression: "new_cost_unit_cost"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("total_cost"),
                        readonly: "",
                        prefix: "$"
                      },
                      model: {
                        value: _vm.new_cost_total_cost,
                        callback: function($$v) {
                          _vm.new_cost_total_cost = $$v
                        },
                        expression: "new_cost_total_cost"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "row gutter-sm justify-end q-mt-sm q-mx-sm layout-padding"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3 q-mx-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "tertiary",
                          label: _vm.$t("cancel"),
                          icon: "fas fa-chevron-left"
                        },
                        on: {
                          click: function($event) {
                            return _vm.clearNewCost()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3 q-mx-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("save"),
                          icon: "far fa-save",
                          disable: _vm.new_cost_total_cost === 0 ? true : false
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveNewCost()
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearNewCost()
            },
            "escape-key": function($event) {
              return _vm.clearNewCost()
            }
          },
          model: {
            value: _vm.show_edit_cost,
            callback: function($$v) {
              _vm.show_edit_cost = $$v
            },
            expression: "show_edit_cost"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_edit_cost = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("edit_cost")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-field",
                      { attrs: { count: 256 } },
                      [
                        _c("q-input", {
                          attrs: {
                            type: "text",
                            "float-label": _vm.$t("description")
                          },
                          model: {
                            value: _vm.new_cost_description,
                            callback: function($$v) {
                              _vm.new_cost_description = $$v
                            },
                            expression: "new_cost_description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("quantity")
                      },
                      on: { input: _vm.calcNewCostTotal },
                      model: {
                        value: _vm.new_cost_qty,
                        callback: function($$v) {
                          _vm.new_cost_qty = $$v
                        },
                        expression: "new_cost_qty"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("unitary_value"),
                        prefix: "$"
                      },
                      on: { input: _vm.calcNewCostTotal },
                      model: {
                        value: _vm.new_cost_unit_cost,
                        callback: function($$v) {
                          _vm.new_cost_unit_cost = $$v
                        },
                        expression: "new_cost_unit_cost"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        "float-label": _vm.$t("total_cost"),
                        readonly: "",
                        prefix: "$"
                      },
                      model: {
                        value: _vm.new_cost_total_cost,
                        callback: function($$v) {
                          _vm.new_cost_total_cost = $$v
                        },
                        expression: "new_cost_total_cost"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "row gutter-sm justify-end q-mt-sm q-mx-sm layout-padding"
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3 q-mx-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "tertiary",
                          label: _vm.$t("cancel"),
                          icon: "fas fa-chevron-left"
                        },
                        on: {
                          click: function($event) {
                            return _vm.clearNewCost()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3 q-mx-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("save"),
                          icon: "far fa-save",
                          disable: _vm.new_cost_total_cost === 0 ? true : false
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateCost(_vm.edit_cost_id)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }